import { render, staticRenderFns } from "./MDApage.vue?vue&type=template&id=00b9f37e&"
import script from "./MDApage.vue?vue&type=script&lang=js&"
export * from "./MDApage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports